/* eslint-disable @typescript-eslint/no-explicit-any */

import { AffiliateParams } from "./affiliateParams";
import { PurchaseOrder } from "./purchaseOrder";
import { ClientConfig } from "./clientConfig";
import { numUtil, typeUtil, urlUtil } from "@repo/lib-common";
import { hashUtil, momentUtil } from "@repo/lib-web";


export class PurchaseOrderTransaction {
  clientConfig: ClientConfig;
  purchaseOrder: PurchaseOrder;
  affiliateParams: AffiliateParams;

  constructor(params: {
    clientConfig: ClientConfig;
    affiliateParams: AffiliateParams;
    purchaseOrder: PurchaseOrder;
  }) {
    this.clientConfig = params.clientConfig!;
    this.affiliateParams = params.affiliateParams!;
    this.purchaseOrder = params.purchaseOrder!;


    this.measurementDateTime = momentUtil.dateTime.now().toIsoString(true);
    this.uri = urlUtil.getWindowUrlString();
  }



  hm: typeUtil.StringOrUndefined;
  r: typeUtil.NumberOrUndefined;
  uri: typeUtil.StringOrUndefined;
  measurementDateTime: string;


  public toApiObject(): any {
    this.r = numUtil.getRandomInt()
    this.hm = hashUtil.hashSha1(
      `${this.clientConfig.measurementId}-${this.affiliateParams.offerId}-${this.affiliateParams.transactionId}-${this.affiliateParams.eventId}-${this.r}`
    );


    const eventData01 = {
      hm: this.hm,
      r: `${this.r}`,
      measurementDateTime: this.measurementDateTime,

      measurementId: this.clientConfig.measurementId,
      advertiserId: this.clientConfig.advertiserId,
      clientDomain: this.clientConfig.clientDomain,
      eventId: this.affiliateParams.eventId,
      transactionId: this.affiliateParams.transactionId,
      offerId: this.affiliateParams.offerId,
      orderNumber: this.purchaseOrder.orderNumber,
      customerId: this.purchaseOrder.customerId,
      salesChannel: this.purchaseOrder.salesChannel,//for backward and forward compat, do not change
      goalName: this.purchaseOrder.goalName,//for backward and forward compat, do not change
      totalAmount: this.purchaseOrder.totalAmount, //for backward and forward compat, do not change
      currencyCode: this.purchaseOrder.currencyCode,
      items: this.purchaseOrder.items?.map(item => item.toApiObject()),

    };
    return eventData01;
  }
}
